/**
 * 公开站首页卡片解析（纯函数）。cards 只含已发布卡，按最近编辑倒序（handleHeptabaseData 排好）。
 * 顺序：后台设置的首页（必须在已发布集合里）→ 标题为 about 的卡 → 最近编辑的一张 → null（空站）。
 * 不再回落 config.js 里写死的卡片 ID：那是单站时代 jopus 的，对其他账号全是错的。
 */
export function resolveHomeCard(cards, site) {
    if (!Array.isArray(cards) || cards.length === 0) return null
    const homeId = site && site.homeNoteId
    if (homeId) {
        const hit = cards.find((c) => c && c.id === homeId)
        if (hit) return hit
    }
    const about = cards.find((c) => c && typeof c.title === 'string' && c.title.trim().toLowerCase() === 'about')
    return about || cards.find(Boolean) || null
}
